import CohealerDashboard from './CohealerDashboardContainer';

export default CohealerDashboard;
